module.exports = new __parcel__URL__("placeholder.faea9478.svg").toString();